import React, { useState, useEffect } from "react";
import "./l001.css";
import starWhite from "../../assets/star-white.png";
import starBlue from "../../assets/star-blue.png";
import paintWhite from "../../assets/paint-white.png";
import paintBlue from "../../assets/paint-blue.png";
import crossicon from "../../assets/rr310/red-x.png";
import expandIcon from "../../assets/rr310/expand.png";
import upshortArrow from "../../assets/up-arrow.png";
import rightcurve from "../../assets/right-curve-arrow.png";
import cancel from "../../assets/cancel.png";
import "reactjs-popup/dist/index.css";
import { useDispatch } from "react-redux";
import { setModelColor } from "../../redux/actions/color-action";
import { setHotspotStatus } from "../../redux/actions/hotspot-action";
import { setHotspotClose } from "../../redux/actions/hotspot-close-action";
import { useSelector } from "react-redux";
import "react-html5video/dist/styles.css";
import Tooltip from "../../components/tooltip";
import HotspotModal from "../../components/hotspotModal";
import VideoModal from "../../components/hotspotVideoModal";
import zoomin from "../../assets/pinch-to-zoom.png";
import rotate from "../../assets/drag-to-rotate.png";
import { BaseUrl } from "../../config.js";
import ExpandIcon from "../../components/expand";
import PlaceholderImage from "../../assets/rr_loader.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const L001 = ({ setExpand, fullScreen }) => {
  const [open, setOpen] = useState(false);
  const [videoModel, setVideoModel] = useState(false);
  const [onColor, setColor] = useState(false);
  const [onHotspot, setHotspot] = useState(false);
  const [hotspotContent, setHotspotContent] = useState([]);
  const [hotspotBaseUrl, setHotspotBaseUrl] = useState();
  const [posterUrl, setPosterUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [longDesc, setLongDesc] = useState(false);
  const [modelToggle, setModelToggle] = useState(false);
  const [colorContent, setColorContent] = useState([]);
  const [tooltip, setTooltip] = useState(true);
  const [colorId, setColorId] = useState();
  const [colorName, setColorName] = useState();
  const [selectedColor, setSelectedColor] = useState(0);

  const dispatch = useDispatch();
  const onHotspotClick = useSelector((state) => state.hotspotClick.status);
  const meshdata = useSelector((state) => state.meshData.data);
  const hotspotdata = useSelector((state) => state.hotspotData.data);

  let curPage = window.location.pathname;
  const pathnameParts = curPage.split("/");
  const pId = pathnameParts[pathnameParts.length - 1];

  useEffect(() => {
    if (onHotspotClick) {
      setOpen(true);
      setHotspotBaseUrl(hotspotdata?.BaseUrl);
      setHotspotContent(
        hotspotdata?.HotspotContent?.filter((i) => i.ID === onHotspotClick)
      );
    }
  }, [onHotspotClick]);

  useEffect(() => {
    meshdata?.length > 0 && setColorId(meshdata[0]?.color[0]?.id);
    meshdata?.length > 0 && setColorName(meshdata[0]?.color[0]?.name);

    meshdata?.map((item, key) => setColorContent(item.color));
  }, [meshdata]);

  const onModelClose = () => {
    setOpen(false);
    setLongDesc(false);
    dispatch(setHotspotClose(modelToggle));
    setModelToggle(!modelToggle);
  };

  const onVidelModel = (poster, video) => {
    setPosterUrl(poster);
    setVideoUrl(video);
    setVideoModel(!videoModel);
  };

  const onModelColor = () => {
    setColor(!onColor);
    setHotspot(false);

    dispatch(setHotspotStatus(false));
  };

  const onModelHotspot = () => {
    setHotspot(!onHotspot);
    setColor(false);
    dispatch(setHotspotStatus(!onHotspot));
  };

  const onColorChange = (color) => {
    dispatch(setModelColor(color));
  };

  return (
    <>
      {tooltip && (
        <div
          className="tooltip-bg"
          onClick={() => {
            setTooltip(false);
            setExpand(true);
          }}
        ></div>
      )}

      <ExpandIcon fullScreen={fullScreen} setExpand={setExpand} />
      {open && (
        <HotspotModal
          onModelClose={() => onModelClose()}
          modalCloseIcon={crossicon}
          hotspotContent={hotspotContent}
          longDesc={longDesc}
          setLongDesc={() => setLongDesc(true)}
          showMoreIcon={expandIcon}
          hotspotBaseUrl={hotspotBaseUrl}
          onVidelModel={onVidelModel}
        />
      )}
      {videoModel && (
        <div
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            width: "100%",
            height: "100%",
          }}
        >
          <VideoModal
            open={videoModel}
            onClick={() => onVidelModel()}
            closeIcon={cancel}
            posterUrl={posterUrl}
            videoUrl={videoUrl}
          />
        </div>
      )}

      {tooltip && (
        <>
          <div className="hotspot-tooltip">
            <Tooltip
              upArrow={true}
              shortArrow={true}
              label={"Hotspot"}
              image={upshortArrow}
            />
          </div>
          <div className="colorswap-tooltip">
            <Tooltip
              curveRight={true}
              label={"Color swap"}
              image={rightcurve}
            />
          </div>

          <div className="zoomin-tooltip">
            <Tooltip
              rotate={true}
              image={zoomin}
              label={"Pinch/scroll for zoom in and zoom out."}
            />
          </div>

          <div className="rotate-tooltip">
            <Tooltip zoomin={true} image={rotate} label={"Drag to rotate"} />
          </div>
        </>
      )}
      {!open && (
        <div className="footer_rr310">
          <img
            src={onHotspot ? starBlue : starWhite}
            className="footer-icons"
            id="hotspot-icon"
            onClick={onModelHotspot}
            alt="hotspot"
          />

          <img
            src={onColor ? paintBlue : paintWhite}
            className="footer-icons"
            id="color-icon"
            onClick={onModelColor}
            alt="color"
          />

          {onColor && (
            <div className="parallelograms">
              <>
                {colorContent.map((item, index) => (
                  <>
                    {item.colorCode ? (
                      <div
                        style={{ backgroundColor: "#" + item.colorCode }}
                        onClick={() => {
                          onColorChange(item.id);
                          setColorId(item.id);
                          setColorName(item.name);
                        }}
                      ></div>
                    ) : (
                      <div>
                        <LazyLoadImage
                          src={BaseUrl() + pId + "/" + item.path}
                          PlaceholderSrc={PlaceholderImage}
                          alt="Image Alt"
                          onClick={() => {
                            onColorChange(item.id);
                            setColorId(item.id);
                            setColorName(item.name);
                            setSelectedColor(index);
                          }}
                        />
                        <p
                          style={{
                            color: selectedColor === index && "#000",
                          }}
                          className="rr_footer_label boldFont"
                        >
                          {item.name}
                        </p>
                      </div>
                    )}
                  </>
                ))}
              </>
            </div>
          )}
        </div>
      )}
      {colorId === "C001" && onColor && colorName && (
        <div className="availability_msg mediumFont">
          *{colorName} is available on TVS Built To Order Only
        </div>
      )}
    </>
  );
};

export default L001;
